import { render, staticRenderFns } from "./SiniestroHogar.vue?vue&type=template&id=47ba3cd1&scoped=true&"
import script from "./SiniestroHogar.vue?vue&type=script&lang=js&"
export * from "./SiniestroHogar.vue?vue&type=script&lang=js&"
import style0 from "./SiniestroHogar.vue?vue&type=style&index=0&id=47ba3cd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba3cd1",
  null
  
)

export default component.exports